import ssClientUtils from '@linkedin/slideshare-client-utils';
import TrackingUtils from './tracking-utils';

(function(ss) {

    var events = {
      SlideShareExternalShareEvent: "SlideShareExternalShareEvent",
    },

    entityTypes = {
      slideshow: 'Slideshow'
    },

    shareTypes = {
      directlink: 'DIRECT_LINK',
      email: 'EMAIL',
      facebook: 'FACEBOOK',
      linkedin: 'LINKEDIN',
      pinterest: 'PINTEREST',
      twitter: 'TWITTER'
    };

  /**
   * Utility for tracking Linkedin events related to external shares. (eg. Facebook, Twitter, etc.)
   * @param {Object} options
   * @param {String|null} appId An optional app id.
   * @param {String|null} options.trackingId The tracking id.
   */
  function ShareTracker(options) {
    var options = options || {};

    this.trackingUtils = new TrackingUtils();
    this.pageKey = ssClientUtils.li.getPageKey();
    this.appId = options.appId || this.trackingUtils.getAppId('sharing');
    this.trackingId = options.trackingId || this.trackingUtils.generateTrackingID();

    this.bodyDefaults = {
      sharingTrackingId: this.trackingId,
      isOwner: false,
      isEmbed: false,
      requestHeader: {
        pageKey: this.pageKey,
        path: window.document.location.pathname,
        userAgent: window.navigator && window.navigator.userAgent
      }
    };
  }

  /**
   * A wrapper for the actual tracking call to trackingUtils. Fills the event
   * fields with defaults before sending.
   * @param {String} eventName The LI tracking name.
   * @param {Object} eventBody A set of tracking fields corresponding with event.
   */
  ShareTracker.prototype.track = function(eventName, eventBody) {
    var eventBody = $.extend({}, this.bodyDefaults, eventBody);
    this.trackingUtils.recordTrackingEvent(this.appId, eventName, eventBody);
  };

  /**
   * Records a LI tracking event for external shares on SlideShare.
   * @param {Object} options Add param description.
   * @param {Number} options.entityId The SlideShare id corresponding to entity being shared.
   * @param {String} options.shareType The external network being shared to.
   * @param {Boolean} options.isOwner Indicates whether user is owner of entity.
   * @param {Boolean} options.isEmbed Indicates whether share is coming from embedded SlideShare player.
   */
  ShareTracker.prototype.shareSlideShow = function(options) {
    var options = options || {},
      entityId = options.entityId,
      shareType = shareTypes[options.shareType];

    if (entityId != null && shareType != null) {
      return this.track(events.SlideShareExternalShareEvent, {
        entityUrn: ssClientUtils.li.getUrn(entityTypes.slideshow, entityId),
        shareType: shareType,
        isOwner: options.isOwner,
        isEmbed: options.isEmbed
      });
    }
  };

  ss.ShareTracker = ShareTracker;

})(window.slideshare_object);
